module.exports = __webpack_public_path__ + "img/service_code.c341f73b.jpg";